<template>
    <div>
        <modal-form v-model="show" :submit="submit" size="md">
            <template v-slot:title>
                Editar Gravame - {{model.uf}} {{model.estado}}
            </template>
            <template v-slot:body>
                <v-row>
                    <v-col cols="4">
                        <input-number format="currency" required label="Carros" v-model="model.valorTipo1" />
                    </v-col>
                    <v-col cols="4">
                        <input-number format="currency" required label="Motos" v-model="model.valorTipo2" />
                    </v-col>
                    <v-col cols="4">
                        <input-number format="currency" required label="Caminhões" v-model="model.valorTipo3" />
                    </v-col>
                </v-row>
            </template>
        </modal-form>
    </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      model: {},
      arquivo: null,
      tiposDocumento: []
    }
  },
  methods: {
    openModal (sender) {
      this.show = true

      if (sender) { this.model = sender }
    },
    submit () {
      const th = this
      th.$api.Kraken.InserirOuAtualizarGravame(th.model).then(function (response) {
        if (th.$api.UI.PostAction(response)) {
          th.show = false
          th.$emit('close', !response.error)
        }
      })
    }
  },
}
</script>
